export var RankCategoryType;
(function (RankCategoryType) {
    RankCategoryType["UPGRADE"] = "upgrade";
    RankCategoryType["DOWNGRADE"] = "downgrade";
})(RankCategoryType || (RankCategoryType = {}));
//# sourceMappingURL=RankCategoryType.js.map